<ng-container *ngIf="pumpControlFeatures">
  <ng-container *ngrxLet="roomStatusFeatureUpdatePending$ as roomStatusFeatureUpdatePending">
    <ng-container *ngrxLet="installationFeaturesStore.isAnyRoomWithDevice$ as isAnyRoomWithDevice">
      <div
        [class.deactivated]="pumpControlFeatures.properties?.active?.value && !isAnyRoomWithDevice"
        gtm="onToggle"
        gtmAction="Single room control supply channel toggle"
        gtmCategory="singleRoomControl"
      >
        <div class="flex flex-row items-center gap-4">
          <p>
            {{ '+INSTALLATIONS.INSTALLATION.SRC.OPTIMIZATION.SUPPLY_CHANNEL' | translate }}
            {{ ' ' + supplyChannelNumber }}
          </p>

          <mat-slide-toggle
            class="flex-grow"
            #pumpSwitch
            [disabled]="
              (pumpControlFeatures.properties?.active?.value && !isAnyRoomWithDevice) ||
              roomStatusFeatureUpdatePending ||
              !status?.properties?.active?.value
            "
            [checked]="pumpControlFeatures.properties?.active?.value"
            (toggleChange)="onPumpControlChange(pumpSwitch)"
            (change)="onPumpControlToggle(pumpSwitch, extractPumpControlId)"
          ></mat-slide-toggle>
        </div>
      </div>
    </ng-container>
  </ng-container>
</ng-container>
